export default __webpack_public_path__ + "static/media/logo-bonus.9bf8aeb8.svg";